import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import { WindowRef } from '../../../core/window';

@Component({
  selector: 'py-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProgressbarComponent implements OnInit, OnDestroy {
  _activeIndex: number;
  _paused: boolean;

  @Output() timeLeft = new EventEmitter<number>();

  @Input() index: number;
  @Input() duration: number;
  @Input() set paused(paused: boolean) {
    this._paused = paused;
    if (paused && this.index === this.activeIndex) {
      const timeLeft = this.duration - this.duration * (this.progressWidth / 100);
      this.timeLeft.emit(timeLeft);
    }
  }
  @Input() set activeSlideId(activeSlide: string) {
    const activeIndex = activeSlide.substring(activeSlide.indexOf('-') + 1);
    this._activeIndex = Number(activeIndex) || 0;
    this.progressWidth = 0;
  }

  get activeIndex(): number {
    return this._activeIndex;
  }

  get paused(): boolean {
    return this._paused;
  }

  progressWidth = 0;
  subscriptions = new Subscription();

  get width(): number {
    if (this.index < this.activeIndex) {
      return 100;
    } else if (this.index > this.activeIndex) {
      return 0;
    }
    return this.progressWidth;
  }

  constructor(
    private cd: ChangeDetectorRef,
    private winRef: WindowRef
  ) {}

  ngOnInit(): void {
    if (!this.winRef.isBrowser()) {
      return;
    }

    this.subscriptions.add(
      interval(this.duration / 100)
        .pipe(filter(() => this.index === this.activeIndex && !this.paused))
        .subscribe(() => {
          if (this.progressWidth < 100 && !this.paused) {
            this.progressWidth = this.progressWidth + 1;
            this.cd.detectChanges();
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
